import React from 'react';
import NumericInput from 'react-numeric-input';
import './BzmNumericInput.css';

export type BzmNumericInputProps = {
  min?: number;
  max?: number;
  value?: number;
  onChange: (value: any) => void;
  format?: (value: number | null) => string;
};

const BzmNumericInput = (props: BzmNumericInputProps) => {
  return (
    <>
      <div className="d-inline-block mr-3" style={{ width: 50 }}>
        <NumericInput
          className="form-control"
          min={props.min}
          max={props.max}
          value={props.value}
          onChange={value => props.onChange(value)}
          strict={true}
          format={props.format ? props.format : value => String(value)}
        />
      </div>
    </>
  );
};

export default BzmNumericInput;
